<template>
<div class="comp d-flex justify-content-center align-items-center">
       <div class="ipsum team">
    <p class="mb-0">Do you have any question about our products, pricing or anything else? Our team is ready to answer all your questions</p>
    <h2 class="text-center mb-0">We'd love to hear from you</h2>
    </div>
    <div class="container call">
  <div class="row w-75 mx-auto">
    <div class="col rounded hear my-5">
      <div class="d-flex flex-column bd-highlight align-items-center">
  <div class="mt-5 bd-highlight">
    <a href="tel:+2348110449018">
        <i class="fas fa-phone-alt art"></i>
    </a>
  </div>
  <div class="mt-3 bd-highlight ipsum team">
    <h5 class="text-center">Talk to Us</h5>
  </div>
  <div class="mt-3 bd-highlight ipsum team">
    <p class="text-center">We are only a call away.<br> Just pick up the phone and chat with us.</p>
  </div>
  <div class="mt-3 bd-highlight">
    <a href="tel:+2348110449018" class="tel"> +234-81-1044-9018</a>
  </div>
</div>
    </div>
    <div class="col rounded hear my-5 ml-5">
      <div class="d-flex flex-column bd-highlight align-items-center">
  <div class="mt-5 bd-highlight">
    <a href="mailto:onyenekwelizabeth@gmail.com">
       <i class="fas fa-comment-alt art"></i>
    </a>
  </div>
  <div class="mt-3 bd-highlight ipsum team">
    <h5 class="text-center">Contact Customer Support</h5>
  </div>
  <div class="mt-3 bd-highlight ipsum team">
    <p class="text-center">Sometimes you need a little help or support.<br> Don't worry... we are here for you.</p>
  </div>
  <div class="mt-3 bd-highlight">
    <a href="mailto:onyenekwelizabeth@gmail.com">
       <button type="button" class="btn btn-lg butt">CONTACT SUPPORT</button>
    </a>
  </div>
</div>
    </div>
  </div>
    </div>
</div>  
</template>

<script>


export default {
   data() {
    return {};
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/page7/banner.vue